import { useEffect } from "react";

interface MetaOptions {
  title: string;
  description: string;
  keywords: string;
  canonicalPath: string;
}

function upsertMeta(name: string, content: string) {
  let el = document.querySelector(`meta[name="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute("name", name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function upsertProperty(property: string, content: string) {
  let el = document.querySelector(`meta[property="${property}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute("property", property);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

export function useDocumentMeta({ title, description, keywords, canonicalPath }: MetaOptions) {
  useEffect(() => {
    document.title = title;
    upsertMeta("description", description);
    upsertMeta("keywords", keywords);

    const origin = window.location.origin;
    const basePath = (window as unknown as { __BASE_PATH__?: string }).__BASE_PATH__ || "/";
    const prefix = basePath.endsWith("/") ? basePath.slice(0, -1) : basePath;
    const url = `${origin}${prefix}${canonicalPath}`;

    let link = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      document.head.appendChild(link);
    }
    link.setAttribute("href", url);

    upsertProperty("og:title", title);
    upsertProperty("og:description", description);
    upsertProperty("og:type", "website");
    upsertProperty("og:url", url);
    upsertMeta("twitter:card", "summary_large_image");
    upsertMeta("twitter:title", title);
    upsertMeta("twitter:description", description);
  }, [title, description, keywords, canonicalPath]);
}